import { ONBOARDING_FULFILLED_BY_TYPES } from "../components/shared/config";

export const isOnboardingByBorrower = (onboardingFulfilledBy) =>
  onboardingFulfilledBy === ONBOARDING_FULFILLED_BY_TYPES.BORROWER_POS ||
  onboardingFulfilledBy ===
    ONBOARDING_FULFILLED_BY_TYPES.CLIENT_SIDE_KYC_SIGNATURE ||
  onboardingFulfilledBy === ONBOARDING_FULFILLED_BY_TYPES.BORROWER_ONLINE;
